import * as React from "react";
import Table from "../../../components/Table/Table";
import { Dimmer } from "semantic-ui-react";
import { setFaultExtraProperties } from "../../../utils/pdApiUtils";
import { editActions } from "../../../actions/editActions";
import { pdApiActions } from "../../../actions/pdApiActions";
import { mainActions } from "../../../actions/mainActions";
import { Filter } from "../../../components/Table/Migration/LegacyTypes";
import _ from "lodash";
import EditFaultCommon from "../../Editing/EditFaultCommon";

/**
 * All the following props are passed from parent component
 */
export type NetworkFaultsTableProps = {
  pdApi: State.PdApi;
  columns: State.ColumnMap;
  mainState: State.Main;
  editedObjectId: number | undefined;
  isEditActive: boolean;
  isLoadingFaults: boolean;
  editActions: typeof editActions;
  pdApiActions: typeof pdApiActions;
  mainActions: typeof mainActions;
  subMenuRoute: State.NetworkSubmenu;
  toggleModal: () => void;
  columnFilters: Filter[];
  setColumnFilters: (subMenuRoute: State.NetworkSubmenu, columnFilter: Filter[]) => void;
};

export const NetworkFaultsTable: React.FC<NetworkFaultsTableProps> = (props) => {
  const { columns, pdApi, mainState, isEditActive, toggleModal, isLoadingFaults, editedObjectId, editActions: editActionsProps, subMenuRoute, setColumnFilters } = props;

  const handleFilterChangeDebouncedRef = React.useRef(
    _.debounce((changedFilters: Filter[]) => {
      setColumnFilters(subMenuRoute, changedFilters);
    }, 500)
  );

  React.useEffect(() => () => {
    props.mainActions.setLastEditedObjectId(undefined);
  }, [props.mainActions]);

  const isFaultSelected = React.useCallback(
    (fault: Api.AnyFault) => fault.id === editedObjectId,
    [editedObjectId]
  );

  const { networkFaults } = pdApi;
  const { editSize, pageSize, isShortenTextEnabled } = mainState;
  
  let networkFaultRows: Api.AnyFault[] = networkFaults ? networkFaults : [];
  networkFaultRows = networkFaultRows.map(row => setFaultExtraProperties(row, pdApi));
  const selectedColumns: State.Column[] = columns["Network Faults"];
  
  const startingPage = mainState.lastEditedObjectId
    ? (networkFaultRows.findIndex(fault => fault.id === mainState.lastEditedObjectId) / // tslint:disable-line: no-bitwise
        mainState.pageSize) >>
      0
    : 0;

  return (
    <div className="flex-1">
      <div className="flex-1">
        <Table
          startingPage={startingPage}
          rows={networkFaultRows}
          loading={isLoadingFaults}
          loadingText="Fetching network faults..."
          columns={selectedColumns}
          isHidingTextActive={isShortenTextEnabled}
          handleRowSelection={editActionsProps.select}
          isRowSelected={isFaultSelected}
          pageSize={pageSize}
          handleFilterChange={handleFilterChangeDebouncedRef.current}
        />
      </div>
      {isEditActive && (
        <Dimmer active={true} page={true}>
          <div className="edit-view dimmer page" style={{ flex: editSize , width : editSize == 0.3 ? "500px" : "1000px" }}>
            <EditFaultCommon toggleModal={toggleModal} columns={columns} />
          </div>
        </Dimmer>
      )}
    </div>
  );
};
